var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTextPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1528 10.32L19.68 7.84725C19.457 7.62489 19.1549 7.50002 18.84 7.50002C18.5251 7.50002 18.223 7.62489 18 7.84725L7.5 18.3505V22.5H11.6495L22.1528 12C22.3751 11.777 22.5 11.4749 22.5 11.16C22.5 10.8451 22.3751 10.543 22.1528 10.32ZM11.0281 21H9V18.9718L16.0807 11.8912L18.1088 13.9193L11.0281 21ZM19.1693 12.8588L17.1412 10.8307L18.8417 9.13028L20.8698 11.1584L19.1693 12.8588Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.75H9.75V7.5H12V6H6V7.5H8.25V12.75Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H3V3H15V6H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H3C2.60218 1.5 2.22064 1.65804 1.93934 1.93934C1.65804 2.22064 1.5 2.60218 1.5 3V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H6V15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextPencil);
export default __webpack_public_path__ + "static/media/ic-text-pencil.624f3ea7c2ca9f4b6d7e9f6f591db0a4.svg";
export { ForwardRef as ReactComponent };